/**
 * @namespace {BX.UI}
 */
export default class ButtonIcon
{
	static UNFOLLOW = 'ui-btn-icon-unfollow';
	static FOLLOW = 'ui-btn-icon-follow';
	static ADD = 'ui-btn-icon-add';
	static STOP = 'ui-btn-icon-stop';
	static START = 'ui-btn-icon-start';
	static PAUSE = 'ui-btn-icon-pause';
	static ADD_FOLDER = 'ui-btn-icon-add-folder';
	static SETTING = 'ui-btn-icon-setting';
	static TASK = 'ui-btn-icon-task';
	static INFO = 'ui-btn-icon-info';
	static SEARCH = 'ui-btn-icon-search';
	static PRINT = 'ui-btn-icon-print';
	static LIST = 'ui-btn-icon-list';
	static BUSINESS = 'ui-btn-icon-business';
	static BUSINESS_CONFIRM = 'ui-btn-icon-business-confirm';
	static BUSINESS_WARNING = 'ui-btn-icon-business-warning';
	static CAMERA = 'ui-btn-icon-camera';
	static PHONE_UP = 'ui-btn-icon-phone-up';
	static PHONE_DOWN = 'ui-btn-icon-phone-down';
	static PHONE_CALL = 'ui-btn-icon-phone-call';
	static BACK = 'ui-btn-icon-back';
	static REMOVE = 'ui-btn-icon-remove';
	static DOWNLOAD = 'ui-btn-icon-download';
	static DONE = 'ui-btn-icon-done';
	static DISK = 'ui-btn-icon-disk';
	static LOCK = 'ui-btn-icon-lock';
	static MAIL = 'ui-btn-icon-mail';
	static CHAT = 'ui-btn-icon-chat';
	static PAGE = 'ui-btn-icon-page';
	static CLOUD = 'ui-btn-icon-cloud';
	static EDIT = 'ui-btn-icon-edit';
	static SHARE = 'ui-btn-icon-share';
	static ANGLE_UP = 'ui-btn-icon-angle-up';
	static ANGLE_DOWN = 'ui-btn-icon-angle-down';
	static EYE_OPENED = 'ui-btn-icon-eye-opened';
	static EYE_CLOSED = 'ui-btn-icon-eye-closed';
}